import React, { useState } from 'react';
import { Box, Flex, Text, Badge, useColorModeValue } from '@chakra-ui/react';
import ReusableAvatar from 'components/Avatar/ReusableAvatar';
import ThreeDotMenu from 'components/Menus/ThreeDotMenu';
import { LockOpen, Ellipsis, Eye, ArchiveRestore} from "lucide-react";
import ReusableDrawer from 'components/Drawers/ReusableDrawer';
import ViewCompartment from './ViewCompartment';
import ReusableModal from 'components/Modals/ReusableModal';

const CompartmentCard = ({
  compartment_id,
  status,
  size,
}) => {
  const [isViewCompartmentOpen, setIsViewCompartmentOpen] = useState(false);
  const [isLockerOpening, setIsLockerOpening] = useState(false);

  const statusColor = status === 'Available' ? 'green' : 'red';
  const textColor = useColorModeValue("gray.500", "white");

  const handleOccupyCompartment = () => {
    console.log("Compartment Occupied");
    // Logic to occupy or empty the compartment
  };

  const handleOpenViewCompartmentDrawer = () => {
    setIsViewCompartmentOpen(true);
  };

  const handleCloseViewCompartmentDrawer = () => {
    setIsViewCompartmentOpen(false);
  };

  const handleOpenCloseLocker = () => {
    setIsLockerOpening(true); 
  };

  const handleCloseOpenLocker = () => {
    setIsLockerOpening(false); 
  };

  const handleConfirmLockerAction = () => {
    console.log(isLockerOpening ? "Locker opened" : "Locker closed");
    handleCloseOpenLocker();
  };

  const menuItems = [
    {
      icon: <Eye size={16} />,
      text: 'View Compartment',
      onClick: handleOpenViewCompartmentDrawer,
    },
    {
      icon: <LockOpen size={16} />,
      text: 'Open Compartment',
      onClick: handleOpenCloseLocker,
    },
    {
      icon: <ArchiveRestore size={16} />,
      text: status === 'Available' ? 'Occupy Compartment' : 'Empty Compartment',
      onClick: handleOccupyCompartment,
    },
  ];

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p="6"
      boxShadow="md"
      maxW="sm"
    >
      {/* Status Badge */}
      <Flex justifyContent="space-between">
        <Badge 
          colorScheme={statusColor} 
          borderRadius="8px"
          height="20px"     
          px="8px"         
        >
          {status}
        </Badge>
        <ThreeDotMenu
          icon={<Ellipsis size={20} color="grey" />}
          items={menuItems}
        />
      </Flex>

      {/* Compartment Avatar and Details */}
      <Flex alignItems="center" direction="column" mt={4}>
        <ReusableAvatar
          name={compartment_id} 
          size="lg"
          mb={4}
        />
        <Text fontWeight="bold" fontSize="lg" color={"black.400"}># {compartment_id}</Text>
        <Text fontSize="sm" color={textColor}>Size: {size}</Text>
      </Flex>

      {/* Compartment Info */}
      <Box mt={4} p={4} borderRadius="md" bg={useColorModeValue("gray.100", "gray.700")}>
        <Flex justifyContent="space-between" alignItems="center">
          <Text fontSize="xs" fontWeight="bold" color={textColor}>Occupancy</Text>
          <Text fontSize="xs" color={textColor}>{status}</Text>
        </Flex>
      </Box>

    

      {/* ReusableDrawer for Viewing Compartment Details */}
      <ReusableDrawer
        isOpen={isViewCompartmentOpen}
        onClose={handleCloseViewCompartmentDrawer}
        headerContent={<Text fontSize="lg" fontWeight="bold">Compartment Details</Text>}
        size="md"
        bodyContent={
          <ViewCompartment compartment={{ compartment_id, status, size }} />
        }
      />

       {/* Open/Close Locker Modal */}
       <ReusableModal
        isOpen={isLockerOpening}
        onClose={handleCloseOpenLocker}
        onConfirm={handleConfirmLockerAction}
        title={isLockerOpening ? "Open Compartment" : "Close Compartment"}
        confirmLabel={isLockerOpening ? "Open" : "Close"}
        cancelLabel="Cancel"
        bodyMessage={isLockerOpening 
          ? "Are you sure you want to open the compartment?" 
          : "Are you sure you want to close the compartment?"}
      />
    </Box>
  );
};

export default CompartmentCard;
